MarketReportsApp.Models.ReportsHistory = Backbone.Model.extend({
	url: function() {
		return '/api/reports/reporthistory/details/' + MarketReportsApp.Variables.ReportID
	}
});